package dev.wyns.ventrova.data.model

/** What a place fries in, matching the `fry_oil` column of the places database. */
enum class FryOil(val databaseValue: String) {
    Plant("plant"),

    /** Beef tallow (ossewit) or another animal fat. */
    Animal("animal"),

    /** Animal fat for some fryers and plant oil for others. */
    Both("both");

    companion object {
        fun fromDatabase(value: String): FryOil? = entries.firstOrNull { it.databaseValue == value }
    }
}

/** Fry oil as shown for a chip shop; other places don't show it. */
enum class FryOilStatus { Plant, Animal, Unknown }

/** Null when the place is not a chip shop. */
val Place.fryOilStatus: FryOilStatus?
    get() = if (category != PlaceCategory.ChipShop) {
        null
    } else {
        when (fryOil) {
            FryOil.Plant -> FryOilStatus.Plant
            FryOil.Animal -> FryOilStatus.Animal
            // Not every fryer is known to be plant-based, so the fries aren't either.
            FryOil.Both, null -> FryOilStatus.Unknown
        }
    }
